// extracted by mini-css-extract-plugin
module.exports = {"defaultButton":"default-button_defaultButton__5ucv5"};